import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../../../webcommon/grid/Grid';
import gridStyles from './SummaryGridStyles.module.scss';

const SummaryGrid = props => (
    <Grid
        columns={ props.summaryGridColumns }
        defaultColumnSpacing={ 2 }
        loading={ props.loading }
        rows={ props.summaryGridRows }
        styles={ gridStyles }
    />
);

SummaryGrid.defaultProps = {
    loading: false,
    summaryGridColumns: [],
    summaryGridRows: []
};

SummaryGrid.propTypes = {
    loading: PropTypes.bool,
    summaryGridColumns: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            id: PropTypes.string
        })
    ),
    summaryGridRows: PropTypes.arrayOf(PropTypes.shape({}))
};

export default SummaryGrid;
